// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"1bb5e645","837":"3f34b1cd","933":"382f11cc"}[chunkId] + ".css";
};